import React from 'react'

const ProductModel = React.lazy(() => import('pages/ProductModel/ProductModel'));
const ProductModelAdd = React.lazy(() => import('pages/ProductModel/ProductModelAdd'));
const ProductModelEdit = React.lazy(() => import('pages/ProductModel/ProductModelEdit'));
const ProductModelDetail = React.lazy(() => import('pages/ProductModel/ProductModelDetail'));
const ProductModelCopy = React.lazy(() => import('pages/ProductModel/ProductModelCopy'));

const ProductModelRoutes = [
    {
        path: '/model',
        exact: true,
        name: 'Quản lý model',
        function: 'MD_PRODUCTMODEL_VIEW',
        component: ProductModel,
    },
    {
        path: '/model/add',
        exact: true,
        name: 'Thêm mới',
        function: 'MD_PRODUCTMODEL_ADD',
        component: ProductModelAdd,
    },
    {
        path: '/model/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'MD_PRODUCTMODEL_EDIT',
        component: ProductModelEdit,
    },
    {
        path: '/model/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'MD_PRODUCTMODEL_VIEW',
        component: ProductModelDetail,
    },
    {
        path: '/model/copy/:id',
        exact: true,
        name: 'Sao chép',
        function: 'MD_PRODUCTMODEL_ADD',
        component: ProductModelCopy,
    },
]

export default ProductModelRoutes
